const DEFAULT_RETRY_DELAYS_MS = [1000, 2000, 4000];

export const isSessionRejected = error => error?.response?.status === 401;

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

// Comparte una unica renovacion entre todas las peticiones simultaneas y solo
// da la sesion por perdida cuando el servidor responde 401. Los fallos de red
// o 5xx (reinicio del backend, suspension del equipo) se reintentan.
export const createSessionRefresher = (
  requestRefresh,
  retryDelaysMs = DEFAULT_RETRY_DELAYS_MS
) => {
  let pending = null;

  const run = async () => {
    for (let attempt = 0; ; attempt += 1) {
      try {
        const { data } = await requestRefresh();
        return data;
      } catch (error) {
        if (isSessionRejected(error) || attempt >= retryDelaysMs.length) {
          throw error;
        }
        await wait(retryDelaysMs[attempt]);
      }
    }
  };

  return () => {
    if (!pending) {
      pending = run().finally(() => {
        pending = null;
      });
    }
    return pending;
  };
};
